"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const SuluFooterNavigation_1 = __importDefault(require("../stores/SuluFooterNavigation"));
const UiStore_1 = __importDefault(require("../stores/UiStore"));
class Footer extends react_1.default.Component {
    footerReaction;
    isLoading = false;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            isLoading: mobx_1.observable,
            channelId: mobx_1.computed,
            language: mobx_1.computed,
            items: mobx_1.computed,
            loadFooterNavigation: mobx_1.action.bound,
        });
    }
    get channelId() {
        return AuthorizationStore_1.default.channelId ?? __APP__.DEFAULT_FOOTER_CHANNEL_ID;
    }
    get language() {
        return UiStore_1.default.language;
    }
    get items() {
        if (!this.channelId || !this.language) {
            return [];
        }
        return SuluFooterNavigation_1.default.getNavigationItems(this.language, this.channelId) ?? [];
    }
    componentDidMount() {
        this.footerReaction = (0, mobx_1.reaction)(() => ({
            channelId: this.channelId,
            language: this.language,
            isLoading: AuthorizationStore_1.default.auth0?.isLoading,
        }), ({ channelId, language, isLoading }) => {
            if (false === isLoading) {
                this.loadFooterNavigation(language, channelId);
            }
        }, {
            fireImmediately: true,
        });
    }
    componentWillUnmount() {
        this.footerReaction?.();
    }
    render() {
        if (this.items.length <= 0) {
            return null;
        }
        return (react_1.default.createElement("footer", { className: "znd-footer" },
            react_1.default.createElement("nav", { className: "znd-footer-navigation" }, this.items.map((item) => {
                return (react_1.default.createElement("a", { key: item.order + item.url, className: "znd-footer-navigation__item", href: item.url, target: "_blank", rel: "noreferrer" }, item.title));
            }))));
    }
    loadFooterNavigation(language, channelId) {
        if (null !== channelId && null !== language && !this.isLoading) {
            this.isLoading = true;
            SuluFooterNavigation_1.default.loadNavigationItems(language, channelId).finally((0, mobx_1.action)(() => {
                this.isLoading = false;
            }));
        }
    }
}
exports.default = (0, mobx_react_1.observer)(Footer);
